const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const STORAGE_KEY = "2bs_utm";

export function captureUtms() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
      const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...existing, ...found }));
    }
  } catch (e) {
    /* keine Speicherung möglich */
  }
}

export function getUtms() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
}
